import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Icon, Segment, Table } from 'semantic-ui-react'
import { useWindowSize } from '../../../../../hooks/useWindowSize'
import { RootState } from '../../../../../store/rootState'
import { IUserDetail } from '../../../../../types/user'
import { checkAdminStatus, checkRole } from '../../../../../utils/checkRole'
import * as CostsActions from '../../../actions/directAndPassTroughCosts'
import ServiceProviderPassTroughBudgetTable from '../../../components/budget/service-provider/ServiceProviderPassTroughBudgetTableComponent'
import { getPassTroughCostsSelector } from '../../../selectors/directAndPassTroughCostsSelector'
import { ICostSearch, ICostSorting, ICostsSortColumn, IPassThroughCost } from '../../../types/directAndPassTroughCosts'
import { IProject } from '../../../types/project'
import PassTroughCostDetailsContainer from '../../activities/PassTroughCostDetailsContainer'
import { sortTasksByKey } from "../../../../../utils/sort";

interface StateProps {
  project: IProject
  costList: IPassThroughCost[]
  sortCosts: ICostSorting
  user: IUserDetail | null
  searchCostsValue: ICostSearch
  selectedCost: IPassThroughCost
}

interface DispatchProps {
  setSortCosts: (sorting: ICostSorting) => void
  updatePassTroughCost: (projectId: number | string, cost: IPassThroughCost) => Promise<IPassThroughCost>
}

type Props = StateProps & DispatchProps

const _passTroughHeader = [
  { text: 'Position', textAlign: 'left' as CanvasTextAlign },
  { text: 'Phase', textAlign: 'left' as CanvasTextAlign },
  { text: 'Supplier', textAlign: 'left' as CanvasTextAlign },
  { text: 'Quantity', textAlign: 'center' as CanvasTextAlign },
  { text: 'Unit Price', textAlign: 'right' as CanvasTextAlign },
  { text: 'Total Costs', textAlign: 'right' as CanvasTextAlign },
  { text: 'Thereof Paid', textAlign: 'right' as CanvasTextAlign },
  { text: 'Labels', textAlign: 'left' as CanvasTextAlign }
]

const ServiceProviderPassTroughContainer = (props: Props): JSX.Element => {
  const {
    project,
    sortCosts,
    user,
    costList,
    searchCostsValue,
    selectedCost,
    setSortCosts,
    updatePassTroughCost,
  } = props

  const [sort, setSort] = useState(sortCosts.column)
  const [costListState, setCostListState] = useState(costList)

  const _size = useWindowSize().width

  useEffect(() => {
    let _costs = costList
    if (searchCostsValue.search !== '') {
      _costs = costList.filter(
        dc => dc.offer_position.toLowerCase().includes(searchCostsValue.search.toLowerCase())
      )
    }
    setCostListState(_costs)
  }, [searchCostsValue, costList])

  const calcTotal = (costs: IPassThroughCost[]) => {
    const numberList = costs.map(a => a.unit_price && a.quantity ? +a.unit_price * +a.quantity : 0)
    const calc = numberList.reduce((a, b) => (a ? a : 0) + (b ? b : 0), 0)
    return calc ? calc : 0
  }

  const calcTotalThereofPaid = (costs: IPassThroughCost[]) => {
    const numberList = costs.map(a => +a.thereof_paid)
    const calc = numberList.reduce((a, b) => a = a + b, 0)
    return calc ? calc : 0
  }

  const onClick = (sortBy: ICostsSortColumn['name']) => {
    const sorting = sortCosts
    sorting.column.direction = sortBy !== sortCosts.column.name ? 'asc' : sortCosts.column.direction === 'asc' ? 'desc' : 'asc'
    sorting.column.name = sortBy
    setSortCosts(sorting)
    setSort({ direction: sorting.column.direction, name: sorting.column.name })
  }

  const renderTableHeader = () => {
    return _passTroughHeader.map((h, idx) => {
      const click = h.text === 'Position' ? 'offer_position' : h.text.toLowerCase()
      return (
        <Table.Cell key={idx} style={{ padding: '0 1rem', display: h.text === 'Position' ? 'flex' : '', alignItems: 'baseline' }}>
          {h.text === 'Position' ?
            <div
              style={{
                display: 'flex',
                alignItems: 'baseline',
                justifyContent: h.textAlign === 'center' ? 'center' : h.textAlign === 'left' ? 'flex-start' : 'flex-end',
                paddingLeft: '40px'
              }}
            >
              <div style={{ fontSize: '14px', color: '#747678' }}>{h.text}</div>
              <div
                style={{ display: 'flex', flexDirection: 'column' }}
                onClick={() => onClick(click as ICostsSortColumn['name'])}
              >
                <Icon
                  name='sort up'
                  style={{
                    color: '#747678',
                    opacity: sort.name === click && sort.direction === 'asc' ? 0.4 : 1,
                    fontSize: '10px'
                  }}
                />
                <Icon
                  name='sort down'
                  style={{
                    marginTop: '-10px',
                    color: '#747678',
                    opacity: sort.name === click && sort.direction === 'desc' ? 0.4 : 1,
                    fontSize: '10px'
                  }}
                />
              </div>
            </div> :
            <p style={{ textAlign: h.textAlign, color: '#747678', paddingRight: h.text === 'Thereof Paid' ? _size > 1800 ? '40px' : '20px' : 0 }}>{h.text}</p>}
        </Table.Cell>
      )
    })
  }

  const updateCost = (cost_update: IPassThroughCost) => {
    updatePassTroughCost(project.id, cost_update)
  }

  const singleCluster = () => {
    const _costs = sortedCosts(costListState)
    return (
      <ServiceProviderPassTroughBudgetTable
        costs={_costs}
        calcTotalCost={calcTotal(_costs)}
        calcTotalThereofPaid={calcTotalThereofPaid(_costs)}
        updateCost={updateCost}
        project={project}
        name='Pass-Through-Costs'
      />
    )
  }

  const renderTable = () => {
    return (
      <Segment style={{ padding: '0 0 16px', margin: '0 0 1rem 0', border: 'none', borderRadius: '.57rem', boxShadow: '0 0 25px -5px #15151511' }}>
        <Table unstackable className='borderless-table-header custom-padding' padded style={{ border: 'none' }}>
          <Table.Header>
            <Table.Row>
              {renderTableHeader()}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {singleCluster()}
          </Table.Body>
        </Table>
      </Segment>
    )
  }

  const sortedCosts = (costs: IPassThroughCost[]) => {
    if (sort.name === 'offer_position') {
      costs = sortTasksByKey(costs, 'key', 'offer_position')
    }
    if (sort.direction === 'desc') {
      costs.reverse()
    }
    return costs.filter(c => c.project_phases)
  }

  return (
    <React.Fragment>
      {user && (checkRole(user, [16]) || checkAdminStatus(user, project)) ? renderTable() : null}
      {selectedCost.id !== '' && selectedCost.project_phases ? <PassTroughCostDetailsContainer /> : null}
    </React.Fragment>
  )
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    project: state.projectsState.project,
    costList: getPassTroughCostsSelector(state),
    sortCosts: state.projectsState.sortCosts,
    user: state.authState.user,
    searchCostsValue: state.projectsState.searchCosts,
    selectedCost: state.projectsState.selectedCost as IPassThroughCost,
  }
}

const mapDispatchToProps = (dispatch: CostsActions.DirectAndPassTroughCostThunkDispatchType): DispatchProps => {
  return {
    setSortCosts: sorting => dispatch(CostsActions.sortCosts(sorting)),
    updatePassTroughCost: async (projectId, cost) => dispatch(CostsActions.updatePassTroughCost(projectId, cost)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiceProviderPassTroughContainer)
